<div (click)="onEditGiftCard()" class="birthday-card d-flex justify-content-between"
  [ngClass]="{ 'reserved-border': birthday.orderStatus === 'waiting_confirmation', 'cancelled-border': birthday.orderStatus === 'cancelled', 'generic-border': birthday.orderStatus === 'generic_magnet' }">
  <div class="w-100">
    <div style="height: 32px;">
      <h3
        [style.color]="isMaleService() ? 'rgba(0, 131, 172, 1)' : 'rgba(255, 104, 231, 1)'">
        <img *ngIf="birthday.orderStatus === 'order_completed'" src="../../../../assets/images/delivered.svg" width="24" height="24" alt=""> {{ birthday.birthdayName }}
      </h3>
      <h4>{{ birthday.roomName }}</h4>
    </div>

    <div>
      <p>{{ birthday.birthdayYears }} years</p>
      <p>Time</p>
    </div>

    <div>
      <h5>{{ birthday.startTime | date : 'd MMMM y' }}</h5>
      <h5>{{ birthday.startTime | date : 'HH:mm' }} - {{ birthday.endTime | date : 'HH:mm' }}</h5>
    </div>
  </div>

  <span *ngIf="birthday.orderStatus === 'waiting_confirmation'" class="reserved-badge card-badge">Reserved</span>
  <span *ngIf="birthday.orderStatus === 'cancelled'" class="cancelled-badge card-badge">Cancelled</span>
  <span
    *ngIf="birthday.orderStatus !== 'waiting_confirmation' && birthday.orderStatus !== 'cancelled' && birthday.orderStatus !== 'generic_magnet'"
    class="personalized-badge card-badge">Personalized</span>
  <span *ngIf="birthday.orderStatus === 'generic_magnet'" class="generic-badge card-badge">Generic</span>
</div>